import { render, staticRenderFns } from "./DocumentsBlock.vue?vue&type=template&id=86b8d612&scoped=true&"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js&"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsBlock.vue?vue&type=style&index=0&id=86b8d612&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b8d612",
  null
  
)

export default component.exports